// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__dsVcy","heading":"Cart_heading__jJM64"};